// @flow
import React from 'react'
import Lifebar from './Lifebar'
import './ArenaCombatantScoreboard.css'
import {getStatusUiModel} from './getStatusUiModel'

class ArenaCombatantScoreboard extends React.Component {

  props: {
    vW: number,
    name: string,
    hp: number,
    maxHp: number,
    pp: number,
    maxPp: number,
    status: string,
    isEnemyTeam: boolean,
    turnBubbles: Array<boolean>
  };

  state: {
    hasRevealed: boolean
  };

  renderTurnBubbles(isEnemyTeam:boolean) {
    const containerStyle = {
      position:"absolute",
      bottom: "-1.2em",
      left: 0,
    };

    // const enemyFill = (
    // `linear-gradient(
    //   -180deg,
    //   #E70018 0%,
    //   #E70018 50%,
    //   #C60A20 50%,
    //   #C60A20 100%`
    // ); //light on top, dark on bottom
    // const friendlyFill = (
    //   `linear-gradient(
    //   -180deg,
    //   #468EE5 0%,
    //   #468EE5 50%,
    //   #1E69C1 50%,
    //   #1E69C1 100%`
    // ); //light on top, dark on bottom


    // const fillColor = isEnemyTeam
    //   ? enemyFill
    //   : friendlyFill;

    const fillClassName = isEnemyTeam
      ? "is-enemy"
      : "is-friendly";

    return (
      <span style={containerStyle}>
        {
          this.props.turnBubbles.map((value, index) => {
            const style = {
              width: "0.8em",
              height: "0.8em",
              //background: fillColor,
              //border: value ? "0.05em solid rgba(255,255,255,0.4)" : "0.05em solid rgba(0,0,0,0.4)",
              border: "0.1em solid #392E4E",
              display: value ? "inline-block" : "none",
              marginRight: "0.3em",
            };
            return (
              <span className={`turn-fill ${fillClassName}`} key={index} style={style} />
            )
          })
        }
      </span>
    )
  }

  renderStatus() {

    if (this.props.status === "normal") {
      return null
    }

    const statusUiModel = getStatusUiModel(this.props.status);

    const statusStyle = {
      position:"absolute",
      right:"-0.4em",
      top:0,
      transform: "translateY(-70%)",
      fontSize: "0.5em",
      color: statusUiModel.textColor,
      textTransform: "uppercase",
      background: "#392E4E",
      padding: "0.5em 0.5em"
    };



    return (
      <div style={statusStyle}>
        {this.props.status}
      </div>
    )
  }

  render() {

    const {name, /*pp,*/ hp, maxHp, isEnemyTeam} = this.props;

    const style = {
      whiteSpace: "nowrap", //Might end up explicitly defining a width. We'll see!
      background: "#fff", //TODO
      padding: "0.5em",
      //see class
    };

    const teamColor = isEnemyTeam ? "#C41127" : "#246BBE";

    const nameStyle = {
      fontSize: "0.6em",
      color: hp > 0 ? teamColor : "#AAA1A1", //team color or gray if dead
      //color: "#392E4E",
      marginBottom: "0.5em",
      textTransform: "uppercase"
    };


    return (
      <div style={style} className="ArenaCombatantScoreboard">
        <div style={nameStyle}>
          {name}
        </div>
        {/*<div>*/}
          {/*{this.getBotText()}*/}
        {/*</div>*/}
        <div>
          <Lifebar
            hp={hp}
            maxHp={maxHp}
            isEnemyTeam={isEnemyTeam}
          />
        </div>
        {
          this.renderStatus()
        }
        {this.renderTurnBubbles(isEnemyTeam)}


        {
          // isEnemyTeam ? null : <div>PP: {pp} / {maxPp}</div>
        }
      </div>
    );
  }
}

export default ArenaCombatantScoreboard;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaCombatantScoreboard.js